<!--  -->
<template>
  <div>
    <div class="sub_wrapper">
      <div class="banner_wrap" style="overflow: hidden">
        <div class="text1">平台运营概况</div>
      </div>
      <div class="w_1200" style="margin: 20px auto 40px;">
        <el-tabs v-model="activeName" type="border-card" >
          <el-tab-pane label="数据统计" name="first">
            <div class="main_wrap">
            <div class="showNum">
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/01惠企政策数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>{{ numData.policyNum }}</span> 个</div>
                  <div class="item_text2">惠企政策</div>
                </div>
              </div>
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/02政策项目数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>{{ numData.policyItemNum }}</span> 个</div>
                  <div class="item_text2">政策项目</div>
                </div>
              </div>
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/03免申即享数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>{{ numData.msjxCount }}</span> 个</div>
                  <div class="item_text2">免申即享政策</div>
                </div>
              </div>
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/04受惠企业家次.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>52.8316</span> 万家次</div>
                  <div class="item_text2">受惠企业</div>
                </div>
              </div>
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/05已兑现金额数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>{{ numData.sumMoney }}</span> 万元</div>
                  <div class="item_text2">奖补资金兑现金额</div>
                </div>
              </div>

              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/06费用减免数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>1130.35</span> 万元</div>
                  <div class="item_text2">费用减免金额</div>
                </div>
              </div>
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/07减租减息数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>350.85</span> 万元</div>
                  <div class="item_text2">减租减息金额</div>
                </div>
              </div>
              <div class="item">
                <div class="item_img">
                  <img src="@/assets/images/08减租减息数.png" alt="" style="height:100%;"/>
                </div>
                <div class="item_text" >
                  <div class="item_text1"><span>799570.28</span> 万元</div>
                  <div class="item_text2">退返减免税费金额</div>
                </div>
              </div>
            </div>
            <div class="text3">奖补资金兑现公示</div>
            <div style="float: right;margin-top: 40px;">
              <div style="float: left;"><el-input placeholder="请输入企业名称" v-model="pagination.qiyeName" style="width: 260px;"/></div>
              <div class="s-button" @click="getData">查 询</div>
            </div>
            <div style="width:100%;margin-top: 100px;border-top:1px solid #eee;">
              <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  width="60">
                </el-table-column>
                <el-table-column
                  prop="qiyeName"
                  label="企业名称"
                  >
                </el-table-column>
                <el-table-column
                  prop="policyName"
                  label="政策名称"
                  width="400">
                </el-table-column>
                <el-table-column prop="deptName" label="主管部门" width="160">
                </el-table-column>
                <el-table-column
                  prop="cashMoney"
                  label="兑现金额（元）"
                  align="center"
                  width="160">
                </el-table-column>
                <el-table-column
                  prop="cashTime"
                  label="兑现时间"
                  align="center"
                  width="200">
                </el-table-column>
              </el-table>
              <el-pagination
                class="pg-css"
                @size-change="handleSizeChange"
                :current-page="pagination.pageNum"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,30,40,50]"
                background
                :page-size="30"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total">
              </el-pagination>
            </div>
          </div>
          </el-tab-pane>
          <el-tab-pane label="《县（区）免申即享政策兑现情况统计》" name="second">
            <div style="margin-top: -20px;">
              <div class="text3">《县（区）免申即享政策兑现情况统计》</div>
              <div style="float: right;margin-top: 40px;">
                <div style="float: left;">
                  <el-date-picker
                    v-model="month"
                    type="month"
                    style="width: 260px;cursor: pointer;"
                    value-format="yyyy-MM"
                    placeholder="请选择年月">
                  </el-date-picker>
                </div>
                <div class="s-button" @click="getData2">查 询</div>
              </div>
              <div style="width:100%;border-top:1px solid #eee;overflow: hidden;">
                <el-table
                  :data="tableData2"
                  style="width: 100%">
                  <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    width="60">
                  </el-table-column>
                  <el-table-column
                    prop="deptName"
                    label="县（区）"
                    >
                  </el-table-column>
                  <el-table-column
                    label="录入免申即享政策总数量(当月数量)"
                    align="center"
                    width="240">
                    <template slot-scope="scope">
                      {{scope.row.msjxslZS}}({{scope.row.msjxslSum}})
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="兑现免申即享企业总数量(当月数量)"
                    align="center"
                    width="240">
                    <template slot-scope="scope">
                      {{scope.row.msjxqysZS}}({{scope.row.msjxqysSum}})
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="企业兑现免申即享政策奖补资金总金额（万元）(当月金额)"
                    align="center"
                    width="240">
                    <template slot-scope="scope">
                      {{scope.row.msjxjbzjZS}}({{scope.row.msjxjbzjSum}})
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="免申即享政策兑现减免退费总金额（万元）(当月金额)"
                    align="center"
                    width="240">
                    <template slot-scope="scope">
                      {{scope.row.msjxjmjeZS}}({{scope.row.msjxjmjeSum}})
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "@/assets/newStyle/css/idx.scss";
  .text1{
    font-size:40px;color: #fff;width:1100px;margin:70px auto;font-weight: 900;letter-spacing: 10px;
  }
  .text2{
    height:100px;font-size:26px;text-align: center;line-height: 100px;letter-spacing: 4px;font-weight: 600;
  }
  .text3{
    height:60px;font-weight: 600;font-size:24px;line-height: 40px;margin-top:40px;padding-left: 4px;

    width:500px;float: left;margin-right: 30px;
  }
  .s-button{
    width:100px;height:40px;background-color: #0A7EF5;display: inline-block;text-align: center;line-height: 40px;color: #fff;
    border-radius: 4px;
    margin-left: 20px;
    cursor: pointer;
  }
</style>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeName: 'first',
      pagination:{
        pageSize: 30,
        total: 0,
        pageNum: 0,
        qiyeName: '',
      },
      month: '',
      numData:{},
      tableData: [],
      tableData2: [],  //  兑现情况统计
      requesturl: "/dev-api/business/sq-apply/policyCountNum",
      requesturl2: "/dev-api/sqentercount/getCountlist", //  兑现情况统计
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  components: { },
  created() {
    this.month = this.Time(new Date(new Date().getFullYear(),new Date().getMonth()-1));
    this.getData();
    this.getData2('0');
  },
  mounted() {
  },
  methods: {
    getData(){
      this.$httpApi
        .get(this.requesturl, this.pagination)
        .then((res) => {
          this.numData = res;
          this.tableData = res.sqAvoidApplyList.rows;
          this.pagination.total = res.sqAvoidApplyList.total;
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },
    //时间解析
    Time(now) {
      let year=new Date(now).getFullYear();
      let month=new Date(now).getMonth()+1;
      if (month < 10) month = "0" + month;
      return year+"-"+month
    },
    getData2(time){ //  兑现情况统计数据
      console.log('---------------',time);
      let monthtime;
      if(time == 0){
        monthtime = this.Time(new Date(new Date().getFullYear(),new Date().getMonth()-1));
      }else{
        monthtime = this.month;
      }

      this.$httpApi
        .get(this.requesturl2, {dxtime: monthtime})
        .then((res) => {
          console.log('res',res);
          if(res.code === 200){
            this.tableData2 = res.data;
          }
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page;
      this.getData();
    },
    handleSizeChange(page) {
      this.pagination.pageSize = page;
      this.getData();
    },

  },
};
</script>
<style lang='scss' scoped>
  .showNum{
    padding: 40px 0 40px 30px;
    border-radius: 20px;
    box-shadow: #ddd 5px 5px 20px;
    overflow-y: hidden;
    .item{
      min-width:230px;
      margin: 20px 20px;
      float: left;
      .item_img{
        width:60px;height:60px;float: left;
        img{
          float: right;
        }
      }
      .item_text{
        height: 60px;float: left;font-weight: 600;font-size:18px;
        margin-left: 10px;
        .item_text1{
          height:30px;line-height: 30px;
          span{
            color: #0A7EF5;font-size:26px;
          }
        }
        .item_text2{
          height:30px;line-height: 30px;
        }
      }
    }
  }
  ::v-deep {


    .searchRight .el-radio-button__inner {
      width: 100px;
      height: 35px;
      line-height: 1;
      font-weight: 500;
      font-size: 16px;
      border: unset;
      color: #000;
      background-color: unset;
      border-radius: 0;
      margin: auto 5px;
    }
    .searchRight .el-radio-button.is-active .el-radio-button__inner {
      border: 1px solid #1472FF;
      color: #1472FF;
      background-color: #ffe2e2;
    }
    .searchRight .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      box-shadow: unset;
    }
    .searchRight .el-range-editor.is-active,
    .el-range-editor.is-active:hover {
      border-color: #1472FF;
    }
    .el-tabs__item {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }
    .el-tabs__item.is-active {
      color: #1472FF;
    }
    .el-tabs__active-bar {
      border-bottom: 2px solid #1472FF;
      color: #1472FF;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1472FF;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #1472FF;
    }
    .el-form-item__label {
      color: #000;
      font-size: 18px;
    }
    .el-radio__label {
      color: #000;
      font-size: 16px;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #000;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #1472FF;
      background: #1472FF;
    }
    .el-dialog__body{
      display: none;
    }
    .upload-demo{
      text-align: left;
    }
    .edit {
      color: #fff;
      background-color: rgb(20, 114, 255);
      border-color: rgb(20, 114, 255);
    }
    .el-dialog__title{
      font-weight: 600;
    }
  }
  .pg-css {
    text-align: center;
    margin-top: 3vh;
  }
</style>
